var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M43.277 13.141c.482.472.723 1.044.723 1.718 0 .673-.24 1.245-.723 1.717L21.084 38.293a2.416 2.416 0 0 1-1.755.707 2.416 2.416 0 0 1-1.755-.707L4.723 25.717A2.313 2.313 0 0 1 4 24c0-.673.24-1.246.723-1.717l3.51-3.435a2.416 2.416 0 0 1 1.754-.707c.688 0 1.273.236 1.755.707l7.587 7.45 16.93-16.59A2.416 2.416 0 0 1 38.012 9c.688 0 1.273.236 1.755.707l3.51 3.434z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.69d12da45899fa43350f5b5e7e4e8aa0.svg";